import { Policy } from "@mui/icons-material";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  Grid,
  Grow,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography
} from "@mui/material";
import { useState } from "react";
import React from "react";
import { OrdiniRitiroContext } from "../../../context";
import { useContext } from "react";
import { useEffect } from "react";
import { CurrencySimbol } from "../../../utilities";
import { useForm } from "../../../hooks";

const Assicurazione = ({ mainForm, scollBott, setMainForm, subtitle, formAutomatico = {} }) => {
  const [checked, setChecked] = useState(mainForm.sceltaAssicurazione);

  //13/08/2026 Greg: quando il ritiro arriva da un Preventivo, l'assicurazione è già
  //quella su cui è stata calcolata la tariffa: la sezione resta visibile/compilata
  //ma non editabile dall'utente.
  const compilatoDaformAutomatico = formAutomatico && Object.keys(formAutomatico).length > 0;

  const {
    state: { valuteList },
    getValute,
  } = useContext(OrdiniRitiroContext);

  useEffect(() => {
    getValute();
    if (formAutomatico.StimaValMerce) {
      setChecked(true);
    }
  }, []);

  const {
    values: assicurazioneForm,
    changeHandler,
    setValues,
  } = useForm(
    {
      StimaValMerce: formAutomatico.StimaValMerce || " ",
      StimaValMerceValuta: formAutomatico.StimaValMerceValuta || "EUR",
    },
    []
  );

  useEffect(() => {
    if (!checked && !formAutomatico.StimaValMerce) {
      setValues({
        ...assicurazioneForm,
        StimaValMerce: "",
        StimaValMerceValuta: "EUR",
      });
    }
    //testCheck(checked)
    setValues({ ...assicurazioneForm, sceltaAssicurazione: checked });
  }, [checked]);

  useEffect(() => {
    //11/08/2026 Greg: updater funzionale (vedi MerceADR/DettaglioMisureMerce) per non
    //perdere questi campi quando più sezioni montano insieme (ordine da Preventivo).
    setMainForm(prev => ({
      ...prev,
      StimaValMerce: assicurazioneForm.StimaValMerce,
      StimaValMerceValuta: assicurazioneForm.StimaValMerceValuta,
    }));
  }, [assicurazioneForm]);

  return (
    <Card
      elevation={0}
      sx={{ background: (theme) => theme.palette.info.main + "20" }}
    >
      <CardHeader
        title={"Assicurazione"}
        subheader={checked? (subtitle !== "" ? (subtitle):("")):("")}
        subheaderTypographyProps={{
          fontWeight: "bold",
        }}
        titleTypographyProps={{
          fontWeight: "bold",
          fontSize: 18,
        }}
        avatar={<Policy />}
        action={
          <FormControlLabel
            control={
              <Switch checked={checked} disabled={compilatoDaformAutomatico} onClick={() => setChecked(!checked)} />
            }
            label=""
          />
        }
      />

      {checked ? (
        <Grow in={checked} timeout={{ appear: 1000, enter: 1000, exit: 1000 }}>
          <CardContent>
            <Grid item container spacing={1}>
              <Grid item xs={12} md={6} lg={6} mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="select-from-nations">Valuta</InputLabel>
                  <Select
                    fullWidth
                    size="small"
                    labelId="select-from-nations"
                    id="select-from-nations"
                    value={assicurazioneForm.StimaValMerceValuta || ""}
                    disabled={compilatoDaformAutomatico}
                    onChange={(e) =>
                      changeHandler("StimaValMerceValuta", e.target.value)
                    }
                    label="Valuta"
                  >
                    <MenuItem value={" "}>Seleziona valuta</MenuItem>
                    {valuteList?.map((params, key) => (
                      <MenuItem key={key} value={params.codice}>
                        {params.codice} - {params.descrizione}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  margin="normal"
                  fullWidth
                  size="small"
                  label="Valore merce"
                  autoComplete="off"
                  value={assicurazioneForm.StimaValMerce || ""}
                  disabled={compilatoDaformAutomatico}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {CurrencySimbol(assicurazioneForm.StimaValMerce)}
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) =>
                    changeHandler("StimaValMerce", e.target.value)
                  }
                />
              </Grid>
            </Grid>
          </CardContent>
        </Grow>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default Assicurazione;
